import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DtcSearchService {

  troubleShootData$ = new BehaviorSubject(null);

  // Add this
  private searchDataSource = new BehaviorSubject<any>(null);
  searchData$ = this.searchDataSource.asObservable();

  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService
  ) { }

  private restoreSearchSource = new BehaviorSubject<boolean>(false);
  restoreSearch$ = this.restoreSearchSource.asObservable();

  setRestoreSearch(value: boolean): void {
    this.restoreSearchSource.next(value);
  }

  // Add these methods
  setSearchData(data: any): void {
    this.searchDataSource.next(data);
  }

  getSearchData(): any {
    return this.searchDataSource.value;
  }

  getDtcComponent() {
    return this.http.get(this.occService.buildUrl(`DTCSearch/components`));
  }

  getDtcType(dtcComponent: String) {
    return this.http.get(
      this.occService.buildUrl(`/DTCSearch/type?component=${dtcComponent}`)
    );
  }

  getOtherDetails(dtcType: string) {
    return this.http.get(
      this.occService.buildUrl(`/DTCSearch/dtcType?dtcType=${dtcType}`)
    );
  }

  getDTCLookUpDetails(data) {
    return this.http.post(
      this.occService.buildUrl(`/DTCSearch/dtcLookUpDetails`),
      data
    );
  }

  submitDtcData(data) {
    return this.http.post(
      this.occService.buildUrl(`DTCSearch/displayDTCResult`),
      data
    );
  }
}